import { Component } from '@angular/core';
import { Platform, ToastController } from 'ionic-angular';
import { NetworkStatusService } from '../services/network-status.service';
import { Router, NavigationStart } from '@angular/router';
import { GtagService } from '../services/gtag.service';
import { GA4Event } from '../services/shared/models/gtag.model';

@Component({
  templateUrl: 'app.html',
})
export class ZeissVisionECP {
  constructor(
    public platform: Platform,
    private networkService: NetworkStatusService,
    private toastCtrl: ToastController,
    private router: Router,
    private gtagService: GtagService
  ) {
    this.platform.ready().then(() => {
      console.log('inited platform');
    });
    window.addEventListener('offline', () => {
      this.networkService.onlineSubject.next(false);
      this.presentToast('Sorry, it seems you are offline. Please check your internet connectivity.');
    });
    window.addEventListener('online', () => {
      this.networkService.onlineSubject.next(true);
      this.presentToast('You are back online.');
    });
    // Dirty way to make sure refreshed don't break the recommendations. Should add recommendations to local storage eventually.
    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        if (!router.navigated) {
          if (event.url !== '/' && event.url !== '/home' && event.url !== '/SMSTerms') {
            console.log('we are not home');
            window.location.href = '/';
          }
        }
      }
    });
  }

  presentToast(message: string) {
    const toast = this.toastCtrl.create({
      message: message,
      position: 'top',
      duration: 4000,
    });
    toast.present();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts